import {AlertTypes, apiClient, FormChipsControlled, Grid, MuiIcons, setAlert, LoadingButton, useTheme, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@leap4/frontend";
import React, {useContext, useEffect, useState} from "react";
import {RootState} from "../../interfaces/root-state.interface";
import {connect, ConnectedProps} from "react-redux";
import {UserViewsContext} from "../../contexts/userViewsContext";
import {userViewsBaseUrl} from "../../config/generals";
import {useQuery} from "react-query";

const {Save: SaveIcon, DoneAll: DoneAllIcon, DeleteForever: DeleteForeverIcon} = MuiIcons;

export enum viewsOptions {
    revenue = "Revenue",
    cost = "Cost",
    profit = "Profit",
    profitPercent = "Profit Percent",
    impressions = "Impressions",
    requests = "Ad Requests",
    adFillRate = 'Ad Fill Rate',
    cpm = 'CPM',
    rpm = 'RPM',
    netRevenue = 'Net Revenue',
    netCost = 'Net Cost',
    netProfit = 'Net Profit',
    completion = 'Completion',
    vcr = 'VCR',
    incomingRequests = 'Incoming Requests',
    fillRate = "Fill Rate",
    serviceCost = "Serving Cost",
}

export enum graphViewsOptions {
    netRevenue = 'Net Revenue',
    netCost = 'Net Cost',
    netProfit = 'Net Profit',
    impressions = "Impressions",
    revenue = "Revenue",
    cost = "Cost",
    profit = "Profit",
    requests = "Ad Requests",
    completion = 'Completion',
    cpm = 'CPM',
    rpm = 'RPM',
    vcr = 'VCR',
    adFillRate = 'Ad Fill Rate',
    incomingRequests = 'Incoming Requests',
    fillRate = "Fill Rate",
    serviceCost = "Serving Cost",

}

const mapStateToProps = (state: RootState) => ({});
const mapActions = {
    setAlert
}

const connector = connect(mapStateToProps, mapActions);
type PropsFromRedux = ConnectedProps<typeof connector>;

export interface IUserViewsDialogProps extends PropsFromRedux {
    isViewsPopupOpen: boolean
    setViewsPopupOpen: (isOpen: boolean) => void,
}

const _UserViewDialog = (props: IUserViewsDialogProps) => {
    const theme = useTheme()
    const {userViews, setUserViews} = useContext(UserViewsContext)
    
    // Simple styling - library now handles the clean look
    const chipsStackProps = {
        style: {margin: '10px 0'},
        sx: { width: '100%' }
    }
    const [chipsOptionsList, setChipsOptionsList] = useState([])
    const [graphChipsOptionsList, setGraphChipsOptionsList] = useState([])
    const [selectedPresetName, setSelectedPresetName] = useState('')
    const [overviewViews, setOverviewViews] = useState([])
    const [tableViews, setTableViews] = useState([])
    const [cardViews, setCardViews] = useState([])
    const [graphViews, setGraphViews] = useState([])
    const [presetNameTextfield, setPresetNameTextfield] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const chipsOptionsList = []
        for (const [key, value] of Object.entries(viewsOptions)) {
            chipsOptionsList.push({key, value})
        }
        const graphChipsOptionsList = []
        for (const [key, value] of Object.entries(graphViewsOptions)) {
            graphChipsOptionsList.push({key, value})
        }
        setChipsOptionsList(chipsOptionsList)
        setGraphChipsOptionsList(graphChipsOptionsList)
    }, [])

    useEffect(() => {
        if (userViews) {
            setOverviewViews(getKeyValueArr(userViews.activePreset.overviewViews))
            setTableViews(getKeyValueArr(userViews.activePreset.tableViews))
            setCardViews(getKeyValueArr(userViews.activePreset.cardViews))
            setGraphViews(getKeyValueArr(userViews.activePreset.graphViews))
            setSelectedPresetName(userViews.activePreset.presetName)
            setPresetNameTextfield(userViews.activePreset.presetName)

        }
    }, [userViews])

    const getKeyValueArr = (chipsArray) => {
        if (!chipsArray) return []
        return chipsArray.map(chip => ({key: chip, value: viewsOptions[chip]}))
    }

    const handleOverviewChips = (chipsArray) => {
        setOverviewViews(getKeyValueArr(chipsArray))
    }
    const handleTableViews = (chipsArray) => {
        setTableViews(getKeyValueArr(chipsArray))
    }
    const handleCardViews = (chipsArray) => {
        setCardViews(getKeyValueArr(chipsArray))
    }
    const handleGraphViews = (chipsArray) => {
        setGraphViews(getKeyValueArr(chipsArray))
    }
    const handleChangeNameTextfield = ({target}) => {
        if (target.value.length > 24) return props.setAlert({msg: "Maximum 24 chars", type: AlertTypes.WARNING})
        setPresetNameTextfield(target.value)
    }


    const onSubmitViewsChange = async (): Promise<boolean> => {
        if (!overviewViews.length || !tableViews.length || !cardViews.length || !graphViews.length) {
            props.setAlert({msg: "Must be at least 1 field for each display", type: AlertTypes.WARNING})
            return false;
        }
        if (!presetNameTextfield) {
            props.setAlert({msg: "Must enter a preset name", type: AlertTypes.WARNING})
            return false;
        }
        const presetNames = userViews.userViewsPresets.map(preset => preset.presetName)
        if (presetNameTextfield !== selectedPresetName) {
            if (_getNumOfOccurrences(presetNames, presetNameTextfield) > 0) {
                props.setAlert({
                    msg: "Preset Names must be unique!",
                    type: AlertTypes.WARNING
                })
                return false;
            }
        }
        const freshPreset = {
            overviewViews: _getKeysOfObjectsArray(overviewViews),
            tableViews: _getKeysOfObjectsArray(tableViews),
            cardViews: _getKeysOfObjectsArray(cardViews),
            graphViews: _getKeysOfObjectsArray(graphViews),
            presetName: presetNameTextfield,
            userId: userViews.activePreset.userId,
            isActivePreset: true,
        }
        let newUserViews = {}
        if (!selectedPresetName) { //IT MEANS IT's NEW PRESET
            const newPreset = (await apiClient.post(userViewsBaseUrl, freshPreset)).data
            const newUserPresets = [...userViews.userViewsPresets, newPreset]
            newUserViews = {userViewsPresets: newUserPresets, activePreset: newPreset}
        } else {
            const presetId = userViews.userViewsPresets.find(preset => preset.presetName === selectedPresetName)._id
            const presetIdx = userViews.userViewsPresets.findIndex(preset => preset.presetName === selectedPresetName)
            const updatedPreset = (await apiClient.patch(userViewsBaseUrl, {
                updatedPreset: freshPreset,
                presetId
            })).data
            const currentUserPresets = [...userViews.userViewsPresets]
            currentUserPresets.splice(presetIdx, 1, updatedPreset)
            newUserViews = {userViewsPresets: currentUserPresets, activePreset: updatedPreset}
        }
        setUserViews(newUserViews)
        props.setAlert({msg: "Saved Successfully", type: AlertTypes.SUCCESS})
        return true;
    }

    const _getKeysOfObjectsArray = (viewsArray) => {
        return viewsArray.map(view => view.key)
    }

    const _getNumOfOccurrences = (array, string) => {
        let count = 0
        array.forEach(el => {
            if (el === string) count++
        })
        return count
    }

    const onChangePreset = (presetName) => {
        if (presetName === "createNewPreset") {
            setSelectedPresetName("")
            setOverviewViews([])
            setTableViews([])
            setCardViews([])
            setGraphViews([])
            setPresetNameTextfield('')
            return
        }
        const newSelectedPreset = userViews.userViewsPresets.find(preset => preset.presetName === presetName)
        setPresetNameTextfield(presetName)
        setSelectedPresetName(presetName)
        setOverviewViews(getKeyValueArr(newSelectedPreset.overviewViews))
        setCardViews(getKeyValueArr(newSelectedPreset.cardViews))
        setTableViews(getKeyValueArr(newSelectedPreset.tableViews))
        setGraphViews(getKeyValueArr(newSelectedPreset.graphViews))
    }

    const onDeletePreset = async () => {
        if (userViews.userViewsPresets.length === 1) return props.setAlert({
            msg: "You must have at least 1 preset",
            type: AlertTypes.WARNING
        })
        const presetId = userViews.userViewsPresets.find(preset => preset.presetName === selectedPresetName)._id
        const presetIdx = userViews.userViewsPresets.findIndex(preset => preset.presetName === selectedPresetName)
         await apiClient.delete(`${userViewsBaseUrl}/${presetId}`)
        const currentUserPresets = [...userViews.userViewsPresets]
        currentUserPresets.splice(presetIdx, 1)
        const newUserViews = {userViewsPresets: currentUserPresets, activePreset: currentUserPresets[0]}
        setUserViews(newUserViews)
        props.setAlert({msg: "Deleted Successfully", type: AlertTypes.SUCCESS})
    }

    const onUseThisPreset = async () => {
        const isSuccess = (await refetchSave()).data
        if (isSuccess) props.setViewsPopupOpen(false)
    }

    const {isLoading: isLoadingDelete, refetch: refetchDelete} = useQuery(
        'delete-preset--query',
        onDeletePreset,
        {
            refetchOnWindowFocus: false,
            cacheTime: 0,
            enabled: false,
            onError: (err: any) => setAlert({msg: err.message, type: AlertTypes.FAILURE})
        });

    const {isLoading: isLoadingSave, refetch: refetchSave, data} = useQuery(
        'save-preset--query',
        onSubmitViewsChange,
        {
            refetchOnWindowFocus: false,
            cacheTime: 0,
            enabled: false,
            onError: (err: any) => setAlert({msg: err.message, type: AlertTypes.FAILURE})
        });

    const {isLoading: isLoadingUsePreset, refetch: refetchUsePreset} = useQuery(
        'use-preset--query',
        onUseThisPreset,
        {
            refetchOnWindowFocus: false,
            cacheTime: 0,
            enabled: false,
            onError: (err: any) => setAlert({msg: err.message, type: AlertTypes.FAILURE})
        });


    useEffect(() => {
        setIsLoading(isLoadingSave || isLoadingDelete || isLoadingUsePreset)
    }, [isLoadingSave, isLoadingDelete, isLoadingUsePreset])


    function move(from, to, arr) {
        const newArr = [...arr];
        const item = newArr.splice(from, 1)[0];
        newArr.splice(to, 0, item);
        return newArr;
    }

    const onDragEndFnOverview = (event) => {
        const newOrder = move(event.source.index, event.destination.index, overviewViews);
        setOverviewViews(newOrder)
    }
    const onDragEndFnTable = (event) => {
        const newOrder = move(event.source.index, event.destination.index, tableViews);
        setTableViews(newOrder)
    }
    const onDragEndFnCard = (event) => {
        const newOrder = move(event.source.index, event.destination.index, cardViews);
        setCardViews(newOrder)
    }
    const onDragEndFnGraph = (event) => {
        const newOrder = move(event.source.index, event.destination.index, graphViews);
        setGraphViews(newOrder)
    }


    return (
        //TODO ADD ON ONCLOSE - BACK TO ORIGINAL STATE CAUSE NOT SAVING
        <Dialog 
            open={props.isViewsPopupOpen} 
            onClose={() => props.setViewsPopupOpen(false)} 
            maxWidth={'md'} 
            fullWidth
            PaperProps={{
                sx: {
                    backgroundImage: 'none',
                    backgroundColor: theme.palette.mode === 'dark' ? '#1e1e2f' : theme.palette.background.paper,
                }
            }}
        >
            <DialogTitle>Views Selection</DialogTitle>
            <DialogContentText sx={{ fontSize: 14, px: 3 }}>Here you can select the fields to display</DialogContentText>
            <DialogContent>
                <Grid container gap={1}>
                    <Grid container gap={1}>
                        {userViews.userViewsPresets.map(preset => {
                            return <Button variant={'contained'} onClick={() => onChangePreset(preset.presetName)}
                                           color={preset.presetName === selectedPresetName ? 'primary' : 'warning'}
                                           key={preset.presetName}>
                                {preset.presetName}
                            </Button>
                        })}
                        <Button variant={'contained'} onClick={() => onChangePreset("createNewPreset")}
                                color={"" === selectedPresetName ? 'primary' : 'warning'}>Create New</Button>
                    </Grid>
                    <Grid container gap={0} alignItems={'center'}>
                        <Grid item lg={10} display={'flex'} justifyContent={'flex-start'} flexDirection={'column'}>
                            <TextField type={'text'}
                                       placeholder={"Enter Preset Name..."}
                                       value={presetNameTextfield}
                                       onChange={handleChangeNameTextfield}
                            />
                        </Grid>
                        <Grid item lg={10} padding={0}>
                            <FormChipsControlled
                                valueKey={'key'}
                                labelKey={'value'}
                                inputName={'Overview Views'}
                                optionsList={chipsOptionsList}
                                enableCreate={false}
                                pureCreate={false}
                                onUpdateItems={handleOverviewChips}
                                disableCloseOnSelect={true}
                                stackProps={chipsStackProps}
                                controlledValue={overviewViews}
                                onDragEndFn={onDragEndFnOverview}
                            />
                        </Grid>
                        <Grid item lg={10} padding={0}>
                            <FormChipsControlled
                                valueKey={'key'}
                                labelKey={'value'}
                                inputName={'Table Views'}
                                optionsList={chipsOptionsList}
                                enableCreate={false}
                                pureCreate={false}
                                onUpdateItems={handleTableViews}
                                disableCloseOnSelect={true}
                                stackProps={chipsStackProps}
                                controlledValue={tableViews}
                                onDragEndFn={onDragEndFnTable}
                            />
                        </Grid>
                        <Grid item lg={10} padding={0}>
                            <FormChipsControlled
                                valueKey={'key'}
                                labelKey={'value'}
                                inputName={'Card Views'}
                                optionsList={chipsOptionsList}
                                enableCreate={false}
                                pureCreate={false}
                                onUpdateItems={handleCardViews}
                                disableCloseOnSelect={true}
                                stackProps={chipsStackProps}
                                controlledValue={cardViews}
                                onDragEndFn={onDragEndFnCard}
                            />
                        </Grid>
                        <Grid item lg={10} padding={0}>
                            <FormChipsControlled
                                valueKey={'key'}
                                labelKey={'value'}
                                inputName={'Graph Views'}
                                optionsList={graphChipsOptionsList}
                                enableCreate={false}
                                pureCreate={false}
                                onUpdateItems={handleGraphViews}
                                disableCloseOnSelect={true}
                                stackProps={chipsStackProps}
                                controlledValue={graphViews}
                                onDragEndFn={onDragEndFnGraph}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                {selectedPresetName &&
                    <LoadingButton variant={'contained'}
                                   color={'error'}
                                   loading={isLoadingDelete}
                                   onClick={() => refetchDelete()}
                                   startIcon={<DeleteForeverIcon/>}
                                   loadingPosition="start"
                                   disabled={isLoading}>
                        Delete
                    </LoadingButton>}
                <LoadingButton variant={'contained'}
                               onClick={() => refetchSave()}
                               startIcon={<SaveIcon/>}
                               loadingPosition="start"
                               loading={isLoadingSave}
                               disabled={isLoading}>
                    Save
                </LoadingButton>
                <LoadingButton variant={'contained'}
                               color={'success'}
                               disabled={isLoading}
                               loading={isLoadingUsePreset}
                               startIcon={<DoneAllIcon/>}
                               loadingPosition="start"
                               onClick={() => refetchUsePreset()}>
                    Use Preset
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}

export const UserViewsDialog = connector(_UserViewDialog)